import Journey from "./Journey";

const steps = [
    {
        target: '[data-tour="create-project-form"]',
        title: "Set up your project",
        content: "Complete the project details here. Choose the name, language, voice, and deployment options.",
        placement: "left-start",
        skipBeacon: true,
    },
    {
        target: '[data-tour="create-project-submit"]',
        title: "Create your project",
        content: "When the required fields are complete, select Submit to create your project.",
        placement: "top",
        skipBeacon: true,
    },
];

export const CreateProjectTour = ({run = false, onFinish}) => (
    <Journey key={String(run)} steps={steps} run={run} onFinish={onFinish}/>
);

export default CreateProjectTour;
